import React from "react";
import { useTranslation } from "react-i18next";
import SingleSelect from "@/components/controls/SingleSelect";
import { HALF_WRAPPER_CLASSNAME } from "../shared";
import { asString, ControlProps } from "../types";

export const SingleSelectControl: React.FC<ControlProps> = ({
  config,
  value,
  onChange,
  name,
  options,
  singleSelect
}) => {
  const { t } = useTranslation();

  return (
    <div className={HALF_WRAPPER_CLASSNAME}>
      <SingleSelect
        fieldName={name}
        options={options ?? []}
        selectedValue={asString(value) || undefined}
        onSelection={(selected) => onChange(String(selected))}
        placeholder={config?.placeholder ?? t("select")}
        showSearch
        clearable
        onClear={() => onChange(undefined)}
        variant={singleSelect?.variant}
        sideOffset={singleSelect?.sideOffset}
      />
    </div>
  );
};
